export const isClientReadOnly = (user, clientOrId) => {
  if (!user || user.role === "superadmin") return false;
  if (typeof clientOrId === "object" && clientOrId?.is_read_only !== undefined) {
    return Boolean(clientOrId.is_read_only);
  }

  const clientId = typeof clientOrId === "object" ? clientOrId?.id : clientOrId;
  const plan = user.agencyPlan;
  if (plan?.plan !== "free" || clientId === null || clientId === undefined) {
    return false;
  }

  const editableIds = Array.isArray(plan.editable_client_ids)
    ? plan.editable_client_ids.map(String)
    : [];
  return !editableIds.includes(String(clientId));
};

// Selector options with writable clients first; read-only ones stay listed but can't be picked.
export const withClientAccess = (options, user, getClient = (option) => option.value) =>
  options
    .map((option) => {
      const readOnly = isClientReadOnly(user, getClient(option));
      return readOnly
        ? { ...option, isReadOnly: true, disabled: true, label: `${option.label} · Solo lectura` }
        : option;
    })
    .sort((a, b) => Number(Boolean(a.isReadOnly)) - Number(Boolean(b.isReadOnly)));

export const readOnlyClientMessage =
  "Este cliente está en modo solo lectura en el plan Free. Puedes consultar toda su información, pero no modificarla.";

export const readOnlyCardMessage =
  "Cliente en solo lectura (plan Free): puedes consultarlo, pero no moverlo ni editarlo.";

// Grey, shadowless card; the hover only lifts the opacity so it reads as "not interactive".
export const readOnlyCardSx = (theme) => ({
  backgroundColor: theme.palette.grey[100],
  borderLeftColor: theme.palette.grey[400],
  boxShadow: "none",
  filter: "grayscale(1)",
  opacity: 0.7,
  transition: "opacity 0.2s",
  "&:hover": { boxShadow: "none", opacity: 0.9 },
});
